// extracted by mini-css-extract-plugin
module.exports = {"root":"Messages_root__1JNmW","header":"Messages_header__3wMfT"};